/* unplugin-vue-components disabled */import { render } from "./BrandLogo.vue?vue&type=template&id=2567a844&ts=true"
import script from "./BrandLogo.vue?vue&type=script&lang=ts"
export * from "./BrandLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/rathasitjearnpasawarn/var/apps/myculture/runner/assessment-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__